import gql from 'graphql-tag'

export default gql`query getCourses {
  getCourses {
		id
		public_type
		visit_type
		status
		detail {
			title
      duration
		}
		created_at
		updated_at
	}
}`



// WEBPACK FOOTER //
// ./src/apollo/graphql/course/getCourses.js